import React from 'react'
import Navbar from '../Components/Navbar'
import contat from '../Assets/Reformer Bed.jpg'
import Footer from '../Components/Footer'
function Contact() {
  return (
    <>
        <Navbar/>
        <div className='aboutbanner aboutbanner6'>
    <h3>Need assistance? Contact us today.</h3>
    <p>HOME - CONTACT US</p>

    </div>
    <div className='contact'>
    <div className='contact-left'>
    <img src={contat}/>

</div>   
<div className='contact-right'>
<h3>Let’s Get In Touch</h3>
{/* <br/> */}
<p className='social-contact'><i class="bi bi-instagram"></i>
    <i class="bi bi-facebook"></i>
    <i class="bi bi-linkedin"></i>
    <i class="bi bi-twitter"></i></p>
<br/>
<label>Your Name</label>
<input placeholder='Enter Your Name'/>
<br/>
<label>Your Email</label>
<input placeholder='Enter Your Email'/>
<br/>
<label>Your Mob. No.</label>
<input placeholder='Enter Your Mob. No.'/>
<br/>
<label>Message</label>
<textarea placeholder='Enter Your Message'/>
<br/>
<button>Send Message</button>
</div>
    </div>
    <div className='conatct-info'>
    
    <div className='conatct-info-div'>
  <div>
  <div className='contact-icon'>
  <i class="bi bi-telephone-fill"></i>
</div>
  </div>
    <h3>Call</h3>
    <p> +971 58 588 7738</p>


    </div>


    <div className='conatct-info-div'>
  <div>
  <div className='contact-icon'>
  <i class="bi bi-envelope-fill"></i>
</div>
  </div>
    <h3>Email</h3>
    <p>info@aluradubai.com </p>
   


    </div>


    <div className='conatct-info-div'>
  <div>
  <div className='contact-icon'>
  <i class="bi bi-geo-alt-fill"></i>
</div>
  </div>
    <h3>Address</h3>
    <p>Al Quoz 1, 17 Al Meydan Street, Villa 1, Behind KML Building - Dubai</p>
    


    </div>

    </div>
    <div className='map'>
    <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.920052638644!2d55.260477099999996!3d25.1721772!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6951a5946393%3A0x94d10e67dd96bb9d!2sAlura!5e0!3m2!1sen!2sin!4v1745406399653!5m2!1sen!2sin"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        
      </div>
    <Footer/>
    </>
  )
}

export default Contact